const extractDateParts = value => {
  const digits = String(value || "").replace(/\D/g, "")

  if (digits.length !== 8) {
    return null
  }

  return {
    day: Number(digits.slice(0, 2)),
    month: Number(digits.slice(2, 4)),
    year: Number(digits.slice(4, 8))
  }
}

export const parseDisplayDate = value => {
  const parts = extractDateParts(value)

  if (!parts) {
    return null
  }

  const date = new Date(parts.year, parts.month - 1, parts.day)
  const isSameDate =
    date.getFullYear() === parts.year &&
    date.getMonth() === parts.month - 1 &&
    date.getDate() === parts.day

  return isSameDate ? date : null
}

export const toApiDate = value => {
  const date = parseDisplayDate(value)

  if (!date) {
    return null
  }

  const day = String(date.getDate()).padStart(2, "0")
  const month = String(date.getMonth() + 1).padStart(2, "0")

  return `${date.getFullYear()}-${month}-${day}`
}

export const toDisplayDate = value => {
  if (!value) {
    return ""
  }

  const [year, month, day] = String(value).slice(0, 10).split("-")

  if (!year || !month || !day) {
    return ""
  }

  return `${day}/${month}/${year}`
}

export const todayDisplayDate = () => {
  const today = new Date()
  const day = String(today.getDate()).padStart(2, "0")
  const month = String(today.getMonth() + 1).padStart(2, "0")

  return `${day}/${month}/${today.getFullYear()}`
}

export const isBeforeToday = value => {
  const date = parseDisplayDate(value)

  if (!date) {
    return false
  }

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return date.getTime() < today.getTime()
}
